<section class="view-notes-container">
    <header>
        <div class="view-notes">
            <cc-icon
                [icon]="'list'"
                [size]="'medium'"
                [color]="'var(--grid-action-color)'"
            >
            </cc-icon>
            <span>{{buttonLabel}}</span>
        </div>

        <cc-button [type]="'naked'" (pressed)="acknowledge.emit()">Got It</cc-button>
     </header>
     <main>
        <h2>{{ title }}</h2>

        @for (note of notes; track note) {
            <p>{{ note }}</p>
        }
     </main>
</section>
